import { Observable } from 'rxjs';
import { ClientService } from '../services/client.service';

export const clientInitializer = (clientService: ClientService) => (): Observable<boolean> => {
	let [client] = window.location.pathname.split('/').filter(path => !!path);

	return clientService.initialize$(client);
};
